import { createDecorator } from '../../instantiation/common/instantiation.js';
const IDownloadService = ( createDecorator('downloadService'));
export { IDownloadService };
